<template>
    <div :class="$style['review-report-ifame']">
        <el-dialog title="移动端报告预览" :visible="isDialog" class="goods-review-dialog" @close="closeDialog">
            <iframe v-if="isDialog" :src="`${apiServer}/parent-page/${this.sampleId}/${this.packageId}/report/常见疾病?jobId=${this.jobId}&fullName=${this.fullName}&labCode=${this.labCode}&agentId=vcangene`" :class="$style['review-iframe']" frameborder="0"></iframe>
        </el-dialog>
    </div>
</template>
<script>

export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    isDialog: {
      type: Boolean,
      default: false
    },
    sampleId: {
      type: String,
      default: ''
    },
    packageId: {
      type: String,
      default: ''
    },
    jobId: {
      type: String,
      default: ''
    },
    fullName: {
      type: String,
      default: ''
    },
    labCode: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      apiServer: this.$apiServerMobile
    }
  },
  methods: {
    closeDialog () {
      this.$emit('closeDialog')
    }
  }

}
</script>
<style lang="less" module>
.review-report-ifame{
:global
.goods-review-dialog{
    overflow: hidden;
    .el-dialog{
        margin-top: 3%!important;
        height: 94%;
        display: flex;
        width: 30%;
        min-width: 350PX;
        max-width: 400PX;
        max-height: 812PX;
        min-height: 667PX;
        flex-direction:column;
        .el-dialog__header{
            .el-dialog__title{
                width: 100%;
                text-align: center;
                display: block
            }
        }
        .el-dialog__body{
            border: 1px dashed #4A91FD;
            padding: 5px;
            flex: 1
        }
    }

}
}
.review-iframe{
    width: 100%;
    height: 100%;
}
</style>
